module.exports = {
    'selectLanguage': 'Select your language',
    'articleFilter': 'Filter articles:',
    'albumFilter': 'Filter albums:',
    'contactUs': 'Contact Us',
    'openingHours': 'Opening Hours',
    'submitButton': 'Submit',
    'formName': 'Your name',
    'formEmail': 'Your email',
    'formMessage': 'Your message',
    'instagramHeader': 'Follow Us on Instagram @centremultisport',
    'socialHeader': 'Check out our social',
    'pageNext': 'Next page',
    'pagePrevious': 'Previous page',
    'partners': 'Our Partners',
    'comingSoon': 'Coming Soon',
    'weekdays': 'Monday to friday',
    'weekends': 'Saturday and sunday',
    'office': 'Office',
    'field': 'Fields',
    'ifRequired': 'as required',
    'moreNews': 'View more news',
    'backToNews': 'Back to news',
    'all': 'All'
  };